enum IItemType {
  Recipe, Buddy, Player, Augmentation
}

export default IItemType;

